import React from 'react';
import { PD, SF } from './tokens';
import StatusPill from './StatusPill';

interface PlanDetailsHeaderProps {
  title: string;
  status?: string;
  isTemplate: boolean;
  onClose: () => void;
}

function statusBadge(status: string): React.ReactNode {
  if (status === 'completed') {
    return (
      <StatusPill tone="success" dot>
        Completado
      </StatusPill>
    );
  }
  if (status === 'pending') {
    return (
      <StatusPill tone="pending" dot>
        Pendiente
      </StatusPill>
    );
  }
  if (status === 'in_progress') {
    return (
      <StatusPill tone="lime" dot>
        En progreso
      </StatusPill>
    );
  }
  if (status === 'expired') {
    return (
      <StatusPill tone="warn" dot>
        Vencido
      </StatusPill>
    );
  }
  return <StatusPill>{status}</StatusPill>;
}

const PlanDetailsHeader: React.FC<PlanDetailsHeaderProps> = ({ title, status, isTemplate, onClose }) => {
  return (
    <div
      style={{
        padding: '14px 14px 14px 22px',
        background: PD.surfaceTranslucent,
        backdropFilter: 'blur(14px) saturate(180%)',
        WebkitBackdropFilter: 'blur(14px) saturate(180%)',
        borderBottom: `0.5px solid ${PD.hairline}`,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flex: '0 0 auto'
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span
            style={{
              fontFamily: SF,
              fontSize: 10.5,
              fontWeight: 700,
              color: PD.ink3,
              letterSpacing: 0.5,
              textTransform: 'uppercase'
            }}
          >
            {isTemplate ? 'Plantilla' : 'Sesión'}
          </span>
          {!isTemplate && status && statusBadge(status)}
        </div>
        <div
          style={{
            fontFamily: SF,
            fontSize: 19,
            fontWeight: 700,
            color: PD.ink,
            letterSpacing: '-0.02em',
            marginTop: 1,
            lineHeight: 1.15,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={title}
        >
          {title}
        </div>
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Cerrar"
        style={{
          width: 30,
          height: 30,
          borderRadius: '50%',
          background: PD.fill,
          color: PD.ink2,
          border: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          padding: 0,
          flex: '0 0 auto'
        }}
      >
        <i className="pi pi-times" style={{ fontSize: 13 }} />
      </button>
    </div>
  );
};

export default PlanDetailsHeader;
